import debounce from 'lodash/debounce';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import Input from 'epn-ui/umd/dist/components/InputText';
import useI18n from '@i18n';

export interface ISearchProps {
    onChange: (filterName: string, value: string) => void;
}

const Search: React.FC<ISearchProps> = ({ onChange }) => {
    const { t } = useI18n('Creatives');

    const debounced = debounce(value => {
        onChange('inputSearch', value);
    }, 300);

    return (
        <Input
            placeholder={t('Search creative')}
            onChange={e => debounced(e.target.value.trim())}
            prefix={<FontAwesomeIcon className="text-blueGray-500" icon={faSearch} />}
            className="mr-2"
        />
    );
};

export default Search;
